import { render, staticRenderFns } from "./ManThrowingAwayPaperIcon.vue?vue&type=template&id=33923412&scoped=true&"
import script from "./ManThrowingAwayPaperIcon.vue?vue&type=script&lang=js&"
export * from "./ManThrowingAwayPaperIcon.vue?vue&type=script&lang=js&"
import style0 from "./ManThrowingAwayPaperIcon.vue?vue&type=style&index=0&id=33923412&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33923412",
  null
  
)

export default component.exports